import { Role } from 'types';
import { computed } from 'vue';
import { useStore } from 'vuex';

export function useRoles() {
  const store = useStore();

  function isUserRole(roles: Role[]): boolean {
    return store.state.userRoles?.some((role: Role) => roles.includes(role));
  }

  const canAccessWorkspaces = computed(() =>
    isUserRole([
      Role.Admin,
      Role.WorkspaceOwner,
      Role.WorkspaceCoworker,
      Role.Reviewer,
    ]),
  );

  const canManageWorkspaces = computed(() =>
    isUserRole([Role.Admin, Role.WorkspaceOwner]),
  );

  const canManageWorkspaceDocuments = computed(() =>
    isUserRole([Role.Admin, Role.WorkspaceCoworker]),
  );

  return {
    isUserRole,
    canAccessWorkspaces,
    canManageWorkspaces,
    canManageWorkspaceDocuments,
  };
}
